export default "__VITE_ASSET__b085909d__"